module.exports = __webpack_public_path__ + "img/library2.8799bd58.jpg";